function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.857 25.11c4.424-6.209 3.851-14.884-1.719-20.454-6.208-6.208-16.274-6.208-22.482 0-6.208 6.208-6.208 16.274 0 22.482 5.57 5.57 14.245 6.143 20.453 1.718L40.253 44 44 40.253 28.857 25.109zM23.39 8.402c4.14 4.14 4.14 10.85 0 14.988-4.138 4.14-10.849 4.14-14.988 0-4.139-4.138-4.139-10.849 0-14.988 4.14-4.139 10.85-4.139 14.988 0z",
  fill: "#D3D5D7"
});

function SvgSearchBigIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearchBigIcon;